Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.httpGetMethod = "GET";
exports.httpPostMethod = "POST";
exports.httpPutMethod = "PUT";
exports.httpDeleteMethod = "DELETE";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "Golden Points";
exports.labelBodyText = "GoldenPoints Body";
exports.btnExampleTitle = "CLICK ME";

exports.ApiUrls = {
  goldenPointsList: "bx_block_cfgoldenpoints0/golden_points",
  goldenPointShow: "bx_block_cfgoldenpoints0/golden_points/",
  goldenPointCreate: "bx_block_cfgoldenpoints0/golden_points",
  goldenPointUpdate: "bx_block_cfgoldenpoints0/golden_points/",
  goldenPointDelete: "bx_block_cfgoldenpoints0/golden_points/",
  excludeDayList: "bx_block_promo_codes/promo_codes/exclude_days_listing",
  sectionList: "bx_block_categories/categories?dropdown=true&name=asc&token=",
  productList: "bx_block_catalogue/catalogues?dropdown=true",
  productGroupListEndPoint: "/bx_block_catalogue/catalogues/parent_products_dropdown",
  taxApi: "bx_block_taxcalculator/taxcalculators?page_no=1&per_page=10",
};

exports.Strings = {
  token: "token",
  goldenPointsList: {
    view: "View",
    edit: "Edit",
    active: "Active",
    deactivate: "Deactivate",
    pageTitle: "Golden Points",
    addGoldenPoint: "Add Goldent Points",
    noRecordFounds: "Golden Point Not found",
    confirmDeactivate: "Confirm Deactivate",
    goldenPointDeactivated: "Golden Point Deactivated",
    backToListing: "Back to Listing",
  },
};
// Customizable Area End
